<template>
  <b-col
    :sm="schemaField.colSm ? schemaField.colSm : ''"
    :md="schemaField.colMd ? schemaField.colMd : ''"
    v-if="
      !('hidden' in schemaField) ||
        ('hidden' in schemaField && schemaField.hidden == false)
    "
  >
    <b-form-group
      v-bind:id="schemaField.groupId"
      v-bind:label="$t(schemaField.i18n.label)"
      v-bind:label-for="schemaField.id"
      v-bind:description="$t(schemaField.i18n.description)"
    >
      <FormInput
        v-if="schemaField.type == 'input'"
        :id="schemaField.id"
        :type="schemaField.inputType"
        :name="schemaField.model"
        :disabled="schemaField.disabled"
        :description="schemaField.description"
        :placeholder="schemaField.placeholder"
        :required="schemaField.required"
        :feedback_id="schemaField.feedback_id"
        :i18n="schemaField.i18n"
        :validations="schemaField.validations"
        :validateState="validateState(schemaField.model)"
        v-model="form[schemaField.model]"
      ></FormInput>

      <FormTextarea
        v-if="schemaField.type == 'textarea'"
        :id="schemaField.id"
        :type="schemaField.inputType"
        :name="schemaField.model"
        :disabled="schemaField.disabled"
        :required="schemaField.required"
        :feedback_id="schemaField.feedback_id"
        :i18n="schemaField.i18n"
        :validations="schemaField.validations"
        :validateState="validateState(schemaField.model)"
        v-model="form[schemaField.model]"
      ></FormTextarea>

      <FormSelect
        v-if="schemaField.type == 'select'"
        :id="schemaField.id"
        :type="schemaField.inputType"
        :name="schemaField.model"
        :options="schemaField.options"
        :clearable="schemaField.clearable"
        :disabled="schemaField.disabled"
        :reduceKey="schemaField.reduceKey"
        :multiple="schemaField.multiple"
        :i18n="schemaField.i18n"
        :feedback_id="schemaField.feedback_id"
        :validations="schemaField.validations"
        :validateState="validateState(schemaField.model)"
        v-model="form[schemaField.model]"
      ></FormSelect>

      <FormSwitch
        v-if="schemaField.type == 'switch'"
        :id="schemaField.id"
        :type="schemaField.inputType"
        :name="schemaField.model"
        v-model="form[schemaField.model]"
      ></FormSwitch>

      <FormRadio
        v-if="schemaField.type == 'radio'"
        :id="schemaField.id"
        :type="schemaField.inputType"
        :name="schemaField.model"
        :options="schemaField.options"
        :rowHorizontal="schemaField.rowHorizontal"
        v-model="form[schemaField.model]"
      ></FormRadio>

      <FormDatepicker
        v-if="schemaField.type == 'datepicker'"
        :id="schemaField.id"
        :type="schemaField.inputType"
        :name="schemaField.model"
        :i18n="schemaField.i18n"
        :feedback_id="schemaField.feedback_id"
        :validations="schemaField.validations"
        :validateState="validateState(schemaField.model)"
        :max="schemaField.max"
        v-model="form[schemaField.model]"
      ></FormDatepicker>
    </b-form-group>
  </b-col>
</template>

<script>
import FormSelect from "@/view/content/forms/components/FormSelect.vue";
import FormSwitch from "@/view/content/forms/components/FormSwitch.vue";
import FormInput from "@/view/content/forms/components/FormInput.vue";
import FormTextarea from "@/view/content/forms/components/FormTextarea.vue";
import FormRadio from "@/view/content/forms/components/FormRadio.vue";
import FormDatepicker from "@/view/content/forms/components/FormDatepicker.vue";

export default {
  name: "FormBuilderInnerPlain",
  props: {
    /**
     * All rows out of the model needed for the form.
     * e.g. id, email, name, phone, active
     */
    form: Object,
    /**
     * Field related parameters.
     * e.g. id, type, inputType, label, model, min, max, required, hint, validator, placeholder, default, clearable, readonly
     */
    schemaField: Object,
    /**
     * index from v-for loop of all fields
     */
    schemaFieldIndex: Number,
    /**
     * Vuelidate state $v
     */
    v: {}
  },
  data() {
    return {};
  },
  components: {
    FormSelect,
    FormSwitch,
    FormInput,
    FormTextarea,
    FormRadio,
    FormDatepicker
  },
  computed: {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.v.form[name];
      return $dirty ? !$error : null;
    }
  }
};
</script>
